export const BALANCE_FRACTIONS = [25, 50, 75, 100];
